import IAuction from "../auction/IAuction";

export function sortAuctionByDateDescending(
    auction1: IAuction,
    auction2: IAuction
) {
    if (auction1.auctionDate > auction2.auctionDate) return -1;
    if (auction1.auctionDate < auction2.auctionDate) return 1;
    return 0;
}

export function sortAuctionByLive(auction1: IAuction, auction2: IAuction) {
    if (auction1.isLive && !auction2.isLive) return -1;
    if (!auction1.isLive && auction2.isLive) return 1;
    return sortAuctionByDateDescending(auction1, auction2);
}
